export function getProgramInstanceFacetParameterString(programInstanceForeignIds) {
  let url = "";
  if (programInstanceForeignIds && programInstanceForeignIds.length > 0) {
    programInstanceForeignIds.forEach((facet, index) => {
      url += `&programInstanceForeignIds[${index}]=${facet}`;
    });
  }
  return url;
}